const defaultTheme = {
  title: 'dark',
  colors: {
    primary: '#aa2000',
    secondary: '#c22049',
    background: '#303030',
    text: '#f6f6f6',
  },
};

export default defaultTheme;
